import { render, staticRenderFns } from "./ProductItemVariantCreate.vue?vue&type=template&id=cd625e92&"
import script from "./ProductItemVariantCreate.vue?vue&type=script&lang=js&"
export * from "./ProductItemVariantCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProductItemVariantCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports